import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["sx", "children"];
var _themeOptions;
import React from 'react';
import { Paper, ThemeProviderNested, extendSX, useThemeProps } from '@lumahealthhq/ui-core';
import { EThemeKey } from '@lumahealthhq/ui-model-types';
import ContainerStyled from './ContainerStyled';
import { jsx as _jsx } from "react/jsx-runtime";
var themeName = 'LumaContainerPaperStyled';
var themeOptions = (_themeOptions = {}, _defineProperty(_themeOptions, EThemeKey.Variant1, {
  styleOverrides: {
    root: {
      '& > .MuiPaper-root': {
        background: 'none'
      }
    }
  }
}), _defineProperty(_themeOptions, EThemeKey.Variant2, {
  styleOverrides: {
    root: {
      // Hide icons from the header
      '& .MuiTypography-h2 > .MuiSvgIcon-root': {
        display: 'none'
      }
    }
  }
}), _themeOptions);
function ContainerPaperStyledRoot(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: themeName
  });
  var sx = props.sx,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(ContainerStyled, _extends({
    sx: extendSX(sx, function (theme) {
      var _ref;
      return _ref = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        '& > .MuiPaper-root': {
          width: theme.breakpoints.values.sm,
          maxHeight: 'fit-content',
          padding: theme.spacing(5)
        }
      }, _defineProperty(_ref, theme.breakpoints.down('md'), {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(0),
        '& > .MuiPaper-root': {
          width: '100%',
          minHeight: '100%',
          maxHeight: 'none',
          borderRadius: 0
        }
      }), _defineProperty(_ref, theme.breakpoints.down('sm'), {
        '& > .MuiPaper-root': {
          padding: theme.spacing(3)
        }
      }), _ref;
    }),
    name: themeName,
    maxWidth: false,
    disableGutters: true
  }, rest, {
    children: /*#__PURE__*/_jsx(Paper, {
      children: children
    })
  }));
}
export default function ContainerPaperStyled(props) {
  return /*#__PURE__*/_jsx(ThemeProviderNested, {
    themeName: themeName,
    themeOptions: themeOptions,
    children: /*#__PURE__*/_jsx(ContainerPaperStyledRoot, _extends({}, props))
  });
}